export const verifyAssociated = async (email: string) => {
  return fetch('/api/amcham/is_associated', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      email
    })
  });
}
